import * as React from 'react';
import * as styles from './KokonIcon16.css';

export const KokonIcon16: React.VFC = () => {
  return <div className={styles['icon']} />;
};
